import React, { useEffect } from 'react';
import { RoomsListPageStyled } from './rooms-list.styled';
import Dashboard from '../../../components/shared/dashboard/dashboard';
import LinearLoading from '../../../components/base/loading/linear-loading/linear-loading';
import i18n from '../../../translations/strings';
import { useDispatch, useSelector } from 'react-redux';
import {
  getRoomsAction,
  roomsResetState,
} from '../../../store/customers/rooms-list.store';
import RoomDetail from '../../../components/shared/room-detail/room-detail/room-detail';
import { useNavigate } from 'react-router-dom';
import { ModalVariant } from '../../../components/shared/modal-provider/components/modal/modal.constants';
import { useModal } from '../../../components/shared/modal-provider/hooks/modal-provider.hook';
const RoomsListPage = () => {
  const { user } = useSelector((state: any) => {
    return state.user;
  });
  const { roomsList, loading, error } = useSelector((state: any) => {
    return state.roomsList;
  });

  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { openModal } = useModal();

  useEffect(() => {
    dispatch(getRoomsAction());
  }, [dispatch]);

  useEffect(() => {
    if (error) {
      openModal({
        message: error,
        variant: ModalVariant.Error,
      });
      dispatch(roomsResetState());
    }
  }, [error]);

  return (
    <Dashboard callingPage={'RoomsListPage'}>
      <RoomsListPageStyled.ContainerPage>
        <LinearLoading loading={loading} />

        <RoomsListPageStyled.Container>
          <RoomsListPageStyled.Title>
            {i18n.t('roomsListPage.title', {
              name: user.first_name,
            })}
          </RoomsListPageStyled.Title>
          <RoomsListPageStyled.SubTitle>
            {i18n.t('roomsListPage.subTitle')}
          </RoomsListPageStyled.SubTitle>

          {roomsList.length > 0 && (
            <>
              <RoomDetail
                buttonTitle={i18n.t('roomsListPage.bookNow')}
                onPressButton={() =>
                  navigate(`/customer/booking/${roomsList[0].id}`)
                }
                room={roomsList[0]}
              />
              <RoomDetail
                buttonTitle={i18n.t('roomsListPage.bookNow')}
                onPressButton={() =>
                  navigate(`/customer/booking/${roomsList[1].id}`)
                }
                room={roomsList[1]}
                imagePosition={'left'}
              />
            </>
          )}
        </RoomsListPageStyled.Container>
      </RoomsListPageStyled.ContainerPage>
    </Dashboard>
  );
};

export default RoomsListPage;
